import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Nav, Tab, Table } from "react-bootstrap";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import Banner from "../../../assets/images/BannerAuditionAdmin.png";
import noImage from "../../../assets/images/settings/no-image.png";
import "../../../Components/SuperStar/Pages/SuperstarAudition/StarAuditionDescription/StarAuditionDescription.css";
import TablePaginationReuse from "../../Audition_static/Audition_admin/TablePaginationReuse";
import LoaderPost from "../../Reuseable/LoaderPost";
import ReUseableSingleRoundTab from "../../Reuseable/ReUseableSingleRoundTab";
import "./AuditionRounds.css";

const AuditiionRoundVideoDistribute = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const { slug } = useParams();
  const [activeRound, setActiveRound] = useState(0);
  const [event, setEvent] = useState({});
  const [videoType, setVideoType] = useState("general");
  const [isVideoAlreadyAssigned, setIsVideoAlreadyAssigned] = useState([]);
  const [distributedVideoArray, setDistributedVideoArray] = useState([]);
  const [juryIdsArray, setJuryIdsArray] = useState([]);
  const [juryGroupList, setJuryGroupList] = useState([]);
  const [judgeList, setJudgeList] = useState([]);
  // const [auditionParticipantList, setAuditionParticipantList] = useState([]);

  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);

  const [auditionRoundInfo, setAuditionRoundInfo] = useState({});
  const [totalVideoNumber, setTotalVideoNumber] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [distributeVideoDate, setDistributeVideoDate] = useState(null);


  const handleAppealedVideos = () => {
    setVideoType("appeal");
    setDistributeVideoDate(Date.now() < new Date(auditionRoundInfo?.appeal_video_upload_end_date).getTime() ? true:false)
  };

  const handleGeneralVideos = () => {
    setVideoType("general");
    setDistributeVideoDate(Date.now() < new Date(auditionRoundInfo?.video_upload_end_date).getTime() ? true:false)
  };

  const handleApplyForJury = () => {
    var useableArray = [];
    let isEverythingPerfect = true;
    Object.values(juryGroupList).forEach((data, index) => {
      let sum = 0;
      distributedVideoArray[index].forEach((element) => {
        sum += element;
      });
      useableArray.push(distributedVideoArray[index]);
      if (sum != totalVideoNumber) {
        isEverythingPerfect = false;
      }
    });

    if (isEverythingPerfect) {
      const formData = new FormData();
      useableArray.forEach((element, index) => {
        var videoList = [];
        element.forEach((ele) => {
          videoList.push(Number(ele));
          formData.append("distributed_videos[" + index + "][]", [Number(ele)]);
        });
      });
      juryIdsArray.forEach((element, index) => {
        var videoList = [];
        element.forEach((ele) => {
          videoList.push(Number(ele));
          formData.append("juries[" + index + "][]", [Number(ele)]);
        });
      });
      formData.append("type", videoType);
      formData.append("audition_id", event?.id);
      formData.append("round_info_id", auditionRoundInfo?.id);
      setLoading1(true);
      axios
        .post(`/api/audition-admin/audition/assign-juries`, formData)
        .then((res) => {
          setLoading1(false);
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            setIsVideoAlreadyAssigned(true);
          } else {
            swal("Opps...", res.data.message, "error");
          }
        });
    } else {
      swal(
        "Opps...",
        "Total number of videos should " + totalVideoNumber,
        "error"
      );
    }
  };

  const handleApplyForJudge = () => {
    const formData = new FormData();
    formData.append("type", videoType);
    formData.append("audition_id", event?.id);
    formData.append("round_info_id", auditionRoundInfo?.id);
    setLoading1(true);
    axios
      .post(`/api/audition-admin/audition/assign-judges`, formData)
      .then((res) => {
        if (res.data.status === 200) {
          setLoading1(false);
          swal("Success", res.data.message, "success");
          setIsVideoAlreadyAssigned(true);
        } else {
          swal("Opps...", res.data.message, "error");
        }
      });
  };

  const fetchAuditionDetails = () => {
    axios.get(`/api/audition-admin/audition-event/with-rounds/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data?.event);
        setActiveRound(res.data?.event?.active_round_info_id);
        //If error the add info
        setRounds(res.data.event?.audition_round);
      }
      setLoading(false);
    });
  };

  const getRoundAndFilterableVideos = () => {
    if (videoType == "general") {
      var apiUrl = `/api/audition-admin/audition/singleAuditionApprovedVideoWithRoundId/${event?.id}/${activeRound}`;
    }
    if (videoType == "appeal") {
      var apiUrl = `/api/audition-admin/audition/appealApprovedVideoWithRoundId/${event?.id}/${activeRound}`;
    }

    axios.get(apiUrl).then((res) => {
      setLoading(false);
      setLoading1(false);
      if (res.data.status === 200) {
        setEvent(res.data.audition);
        setJudgeList(res?.data?.audition?.assigned_judges);
        setAuditionRoundInfo(res.data.auditionRoundInfo);
        setJuryGroupList(res.data.assignJuriesOrderByGroup);
        // setAuditionParticipantList(res.data.auditionParticipantWithVideos);
        setTotalVideoNumber(res.data.totalNumberOfVideos);
        setIsVideoAlreadyAssigned(res.data.isVideoAlreadyAssigned);

        var dummyDistributedVideoArray = [];
        var dummyJuryIdsArray = [];
        var totalVideosNumbers = res.data.totalNumberOfVideos;
        Object.values(res.data.assignJuriesOrderByGroup).forEach(
          (juriesInASingleGroup) => {
            // mark for per jury group
            var videoPackArray = [];
            var juryIdArray = [];
            var total_jury = juriesInASingleGroup.length;

            juriesInASingleGroup.forEach((assignJury) => {
              juryIdArray.push(assignJury?.jury_id);
              var video_pack = Math.floor(totalVideosNumbers / total_jury);

              for (total_jury; total_jury > 0; total_jury--) {
                if (total_jury == 1) {
                  videoPackArray.push(totalVideosNumbers);
                } else {
                  videoPackArray.push(video_pack);
                  totalVideosNumbers = totalVideosNumbers - video_pack;
                }
              }
            });
            total_jury = juriesInASingleGroup.length;
            dummyDistributedVideoArray.push(videoPackArray);
            dummyJuryIdsArray.push(juryIdArray);
            videoPackArray = [];
            juryIdArray = [];
            totalVideosNumbers = res.data.totalNumberOfVideos;
          }
        );
        setDistributedVideoArray(dummyDistributedVideoArray);
        setJuryIdsArray(dummyJuryIdsArray);
      }
    });
  };

  useEffect(() => {
    if (activeRound) {
      getRoundAndFilterableVideos();
    }
    
  }, [activeRound]);

  useEffect(() => {
    if (activeRound) {
      getRoundAndFilterableVideos();
    }
  }, [videoType]);

  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);

  const tableHead = ["Name", "Email", "Video"];

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <div className="container-lg">
          <div>
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={activeRound}
            >
              <div className="container-lg">
                <Nav variant="pills">
                  <div className="row">
                    {rounds &&
                      rounds.map((auditionRound, index) => (
                        <ReUseableSingleRoundTab
                          key={index}
                          auditionRound={auditionRound}
                          setActiveRound={setActiveRound}
                        />
                      ))}
                  </div>
                </Nav>
                <div className="my-4"></div>
              </div>
            </Tab.Container>
          </div>
          <div>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="d-flex justify-content-center">
                <div className="col-md-md-6 small-live-session mb-3">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="first"
                      className="TabCardGold d-flex  text-decoration-none text-center me-2 fw-bold pt-3 "
                      onClick={handleGeneralVideos}
                    >
                      <h5 className="font-style fw-bold">General Videos</h5>
                    </Nav.Link>
                  </Nav.Item>
                </div>
                <div className="col-md-md-6 small-live-session">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="second"
                      className="TabCardGold py-2 fw-bold pt-3 text-decoration-none text-center "
                      onClick={handleAppealedVideos}
                    >
                      <h5 className="font-style fw-bold">Appealed Videos</h5>
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="first"></Tab.Pane>

                <Tab.Pane eventKey="second"></Tab.Pane>
              </Tab.Content>
            </Tab.Container>

            <div className="photoRelative">
              <div className="card card-bg p-2">
                <img
                  style={{ maxHeight: "400px" }}
                  src={event?.banner ? imageCdnUrl + event?.banner : Banner}
                  className="img-fluid audioBanner w-100"
                  alt=""
                />
                <h5 className="BannerPs">
                  Round {auditionRoundInfo?.round_num} time duration{" "}
                  {moment(auditionRoundInfo?.round_start_date).format("LL")} -{" "}
                  {moment(auditionRoundInfo?.round_end_date).format("LL")}
                </h5>
              </div>
            </div>
            <div>
              <>
                {/* <TablePaginationReuse tableHead={tableHead} data={auditionParticipantList} /> */}
              </>
            </div>
            <div className="AssignedBg p-3  my-3">
              <div className="row">
                <div className="">
                  <h4
                    style={{ color: "rgb(249 168 212)" }}
                    className="text-pink-300 text-center fw-bold mb-4"
                  >
                    Assigned Total {totalVideoNumber} videos
                  </h4>
                </div>
              </div>

              {auditionRoundInfo?.has_jury_or_judge_mark == 0 ? (
                <>
                  {juryGroupList &&
                    Object.values(juryGroupList).map(
                      (juriesInASingleGroup, parentIndex) => (
                        <div key={parentIndex} className="StarAdminBc">
                          <div className="d-flex justify-content-between align-items-center MoBds">
                            <div className=" text-light px-2 py-2 GroupHeader mb-3">
                              <b>
                                Group{" "}
                                {
                                  Object.values(juryGroupList)[parentIndex][0]
                                    ?.jury_group?.name
                                }
                              </b>
                            </div>
                            <div className=" p-3 GroupHeaderS mb-3">
                              <h5>Auto Assign</h5>
                            </div>
                          </div>
                          <center className="row justify-content-center align-items-center my-4 p-3">
                            {juriesInASingleGroup.map((assignJury, index) => (
                              <div key={index} className="col-md-4 mb-5 ">
                                <div className="BXCStar  pb-3 mb-3">
                                  <center>
                                    <img
                                      src={
                                        assignJury?.user?.image != null
                                          ? imageCdnUrl + assignJury?.user?.image
                                          : noImage
                                      }
                                      alt="JuryImage"
                                      width={120}
                                      height={120}
                                      style={{ borderRadius: "50%" }}
                                      className="my-3"
                                    />
                                    <h4 className="text-light">
                                      {assignJury?.user?.first_name}{" "}
                                      {assignJury?.user?.last_name}
                                    </h4>
                                    <h6 className="TextNX">
                                      {assignJury?.user?.category.name}
                                    </h6>
                                    <h6 className="TextNX mb-4">Specialist</h6>
                                    <div className="d-flex DBtv justify-content-center ">
                                      {distributedVideoArray.length > 0 ? (
                                        <>
                                          {isVideoAlreadyAssigned ? (
                                            <>
                                              <input
                                                readOnly
                                                type="text"
                                                className="from-control RoundVr p-2"
                                                value="Already Assigned"
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <input
                                                type="number"
                                                className="from-control RoundVr p-2"
                                                onChange={(e) =>
                                                  setDistributedVideoArray([
                                                    ...distributedVideoArray,
                                                    (distributedVideoArray[
                                                      parentIndex
                                                    ][index] = Number(
                                                      e.target.value
                                                    )),
                                                  ])
                                                }
                                                value={
                                                  distributedVideoArray.length >
                                                    0 &&
                                                  distributedVideoArray[
                                                    parentIndex
                                                  ][index]
                                                }
                                              />
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </center>
                                </div>
                              </div>
                            ))}
                          </center>
                        </div>
                      )
                    )}
                  <center>
                    {isVideoAlreadyAssigned ? (
                      <button className="btn border-success text-success p-2 my-5">
                        Already Assigned!
                      </button>
                    ) : (
                      <button
                        onClick={handleApplyForJury}
                        className="btn btnCreate fw-bold"
                        disabled={distributeVideoDate !== null ?distributeVideoDate:Date.now() < new Date(auditionRoundInfo?.video_upload_end_date).getTime() ? true:false}
                      >
                        {loading1 ? (
                          <>
                            <i className="fas fa-spinner fa-pulse"></i> &nbsp;
                          </>
                        ) : null}
                        Apply For Jury
                      </button>
                    )}
                  </center>
                </>
              ) : (
                <>
                  <div className="StarAdminBc">
                    <div className="d-flex justify-content-between align-items-center MoBds">
                      <div className=" text-light p-3 GroupHeader mb-3">
                        <h5>Judge Group</h5>
                      </div>
                      <div className=" p-3 GroupHeaderS mb-3">
                        <h5>Auto Assign</h5>
                      </div>
                    </div>
                    <center className="row justify-content-center align-items-center my-4 p-3">
                      {judgeList.map((assignJudge, index) => (
                        <div className="col-md-4 mb-5 ">
                          <div className="BXCStar  pb-3 mb-3">
                            <center>
                              <img
                                src={
                                  assignJudge?.user?.image != null
                                    ? imageCdnUrl + assignJudge?.user?.image
                                    : noImage
                                }
                                alt="Jury Image"
                                width={120}
                                height={120}
                                style={{ borderRadius: "50%" }}
                                className="my-3"
                              />
                              <h4 className="text-light">
                                {assignJudge?.user?.first_name}{" "}
                                {assignJudge?.user?.last_name}
                              </h4>
                              <h6 className="TextNX">
                                {assignJudge?.user?.category.name}{" "}
                              </h6>
                              <h6 className="TextNX mb-4">Specialist</h6>
                              <div className="d-flex DBtv justify-content-center ">
                                <input
                                  type="number"
                                  className="from-control RoundVr p-2"
                                  value={totalVideoNumber}
                                />
                              </div>
                            </center>
                          </div>
                        </div>
                      ))}
                    </center>
                  </div>

                  <center>
                    {isVideoAlreadyAssigned ? (
                      <button className="btn border-success text-success p-2 my-5">
                        Already Assigned!
                      </button>
                    ) : (
                      <button
                        onClick={handleApplyForJudge}
                        className="btn btnCreate fw-bold"
                        disabled={distributeVideoDate !== null ?distributeVideoDate:Date.now() < new Date(auditionRoundInfo?.video_upload_end_date).getTime() ? true:false}
                      >
                        {loading1 ? (
                          <>
                            <i className="fas fa-spinner fa-pulse"></i> &nbsp;
                          </>
                        ) : null}
                        Apply For Judge
                      </button>
                    )}
                  </center>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AuditiionRoundVideoDistribute;
